import { Grid } from '@mantine/core';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const WebhooksStats = ({ stats, webhook, period, currency }) => {
  const { accountId, domainId } = useParams();

  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${webhook.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  if (!stats) {
    return (
      <Grid justify="center">
        <Grid.Col span={12}>
          <LazyLoadSpinner />
        </Grid.Col>
      </Grid>
    );
  }

  return (
    <Grid>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center">
        <HeaderStatistic
          title="Sent"
          stats={stats}
          stat="sent"
          id={webhook.id}
          statKey="count"
          link={segmentLink('webhookSend')}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center">
        <HeaderStatistic
          title="Delivered"
          stats={stats}
          stat="deliveries"
          percentageOfStat="sent"
          id={webhook.id}
          statKey="count"
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center">
        <HeaderStatistic
          title="Clicks"
          stats={stats}
          stat="clicks"
          percentageOfStat="deliveries"
          id={webhook.id}
          statKey="count"
          link={segmentLink('webhookClicks')}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center">
        <HeaderStatistic
          title="Conversions"
          stats={stats}
          stat="conversions"
          percentageOfStat="clicks"
          id={webhook.id}
          statKey="count"
          link={segmentLink('webhookConversion')}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center">
        <HeaderStatistic
          title="Purchases"
          stats={stats}
          stat="purchases"
          percentageOfStat="conversions"
          id={webhook.id}
          statKey="count"
          link={segmentLink('webhookPurchase')}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center">
        <HeaderStatistic
          title="Revenue"
          stats={stats}
          stat="purchases"
          id={webhook.id}
          statKey="value"
          currency={currency}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center" style={{ borderLeft: '1px dotted' }}>
        <HeaderStatistic
          title="Skipped"
          stats={stats}
          stat="skipped"
          percentageOfStat="sent"
          id={webhook.id}
          statKey="count"
        />
      </Grid.Col>
      <Grid.Col span={{ base: 6, sm: 'auto' }} ta="center" style={{ borderLeft: '1px dotted' }}>
        <HeaderStatistic
          title="Bounces"
          stats={stats}
          stat="bounces"
          id={webhook.id}
          statKey="count"
          link={segmentLink('webhookBounce')}
        />
      </Grid.Col>
    </Grid>
  );
};
export default WebhooksStats;
